import React, { useState, useEffect, use } from 'react'
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
    Scatter, ComposedChart, Line,
} from 'recharts';

import { getMonthWiseLoanApplicationByDateAPI, SaveLockLoanApplicationMonthData } from './ActionCreator';
import moment from 'moment';
import Loader from '../../../presentationals/Loader/Loader.component'
import MenuBar from './MenuBar'
import Popup from '../../../presentationals/Popup/Popup.component'
const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}


const CACDashboard = ({ nbfcList, admin }) => {
    const [view, setView] = useState("list")
    const [loader, setLoader] = useState(false)
    const [GraphBoxHeight, setGraphBoxHeight] = useState("")
    const [selectedDataIndex, setselectedDataIndex] = useState("-1")
    const [selectedDataHeading, setselectedDataHeading] = useState("")
    const [selectedData, setselectedData] = useState([])
    const [ActiveMonthFilter, setActiveMonthFilter] = useState("")
    const [editData, setEditData] = useState({ show: false, data: {} })
    const [editedValues, setEditedValues] = useState({});
    const [ListType, setListType] = useState("list")
    const [APIData, setAPIData] = useState()
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [payload, setPayload] = useState({
        fromDate: InitalDate("fromDate"),
        toDate: InitalDate("toDate"),
        nbfcId: '',
        productId: ''
    })


    useEffect(() => {
        getMonthWiseCollectionEfficiencyByDateFn(payload)
    }, [])

    const handleDate = (e, type) => {
        if (type === "applyFilter") {
            setActiveMonthFilter("")
            setselectedDataIndex("-1")
            setselectedDataHeading("")
            setselectedData([])
            getMonthWiseCollectionEfficiencyByDateFn(payload)
        } else {
            setPayload((prev) => ({
                ...prev,
                [type]: e.target.value
            }))
        }
    }

    const handlemonthFilter = (type) => {
        setActiveMonthFilter(type)
        const { fromDate, toDate } = getDateRange(type);
        const obj = {
            fromDate: fromDate,
            toDate: toDate,
            nbfcId: payload?.nbfcId || "",
            productId: payload?.productId || ""
        }
        setPayload(obj)
        setselectedDataIndex("-1")
        setselectedDataHeading("")
        setselectedData([])
        getMonthWiseCollectionEfficiencyByDateFn(obj)
    }



    const getMonthWiseCollectionEfficiencyByDateFn = (data) => {
        const sDate = moment(data?.fromDate).format("DD-MM-YYYY")
        const eDate = moment(data?.toDate).format("DD-MM-YYYY")
        setLoader(true)
        getMonthWiseLoanApplicationByDateAPI(sDate, eDate, data?.nbfcId, data?.productId, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setAPIData(callback?.data)
                setTimeout(() => {
                    HandlechartHeight()
                }, 200)
            } else {
                setAPIData([])
            }
        })
    }

    const handleSelectedRow = (fieldKey, index) => {
        if (ListType == "edit") {
            setselectedDataIndex("-1")
            setselectedDataHeading("")
            setselectedData([])
        } else {
            if (selectedDataIndex == index) {
                setselectedDataIndex("-1")
                setselectedDataHeading("")
                setselectedData([])
            } else {
                setselectedDataHeading(fieldKey)
                setselectedDataIndex(index)
                const formattedData = APIData?.map(item => ({
                    date: item?.monthName,
                    value: item?.[fieldKey]
                }));

                setselectedData(formattedData);
            }
        }
    }

    const HandlechartHeight = () => {
        let ele = document.getElementById("tableHeight")?.clientHeight;
        setGraphBoxHeight(ele)
    }

    const handleEdit = (value, data) => {
        setEditData({ show: value, data: data })
        if (value == true) {
            setListType("edit")
            setEditedValues(data)
            setselectedDataIndex("-1")
            setselectedDataHeading("")
            setselectedData([])
        } else {
            setListType("list")
            getMonthWiseCollectionEfficiencyByDateFn(payload)
        }
    }

    const handleSavingApi = (type, data) => {
        console.log("editedValues", editedValues, "da", data)
        if (type == "lock") {
            const obj = {
                "applicationsNewAndRepeat": data?.Applications_New_And_Repeat,
                "applicationsNew": data?.Applications_New,
                "applicationsRepeat": data?.Applications_Repeat,
                // "softApprovedNewAndRepeat": 90,
                // "softApprovedNew": 55,
                // "softApprovedRepeat": 35,
                "confirmedApprovedNewAndRepeat": data?.Approved_Applications_New_And_Repeat,
                "confirmedApprovedNewLoan": data?.Approved_Applications_New,
                "confirmedApprovedRepeatLoan": data?.Approved_Applications_Repeat,
                "disbursedNewAndRepeating": data?.Disbursed_Applications_New_And_Repeat,
                "disbursedNew": data?.Disbursed_Applications_New,
                "disbursedRepeating": data?.Disbursed_Applications_Repeat,
                "nonDisbursedNew": data?.Non_Disbursed_Applications_New,
                "nonDisbursedRepeating": data?.Non_Disbursed_Applications_Repeat,
                "nonDisbursedNewAndRepeating": data?.Non_Disbursed_Applications_New_And_Repeat,
                "outstandingPrincipalLoanAmount": data?.Outstanding_Principal_Loan_Amount,
                "forecloseCount": data?.Foreclose_Count,
                "lock": true,
                "month": data?.Month_Name,
                "createdBy": admin.emailId
            }
            SaveLockLoanApplicationMonthData(obj, callback => {
                console.log("locked")
                if (callback && callback?.message == "success" && callback?.status == 200 ) {
                    setpopup({ show: true, popupStatus: 'Data Locked Successfully' })
                    getMonthWiseCollectionEfficiencyByDateFn(payload)
                } else {
                    setpopup({ show: true, popupStatus: 'error Locking' })
                }
                removePopup()
            })
        } else if (type == "save") {
            const obj = {
                "applicationsNewAndRepeat": editedValues?.Applications_New_And_Repeat,
                "applicationsNew": editedValues?.Applications_New,
                "applicationsRepeat": editedValues?.Applications_Repeat,
                // "softApprovedNewAndRepeat": 90,
                // "softApprovedNew": 55,
                // "softApprovedRepeat": 35,
                "confirmedApprovedNewAndRepeat": editedValues?.Approved_Applications_New_And_Repeat,
                "confirmedApprovedNewLoan": editedValues?.Approved_Applications_New,
                "confirmedApprovedRepeatLoan": editedValues?.Approved_Applications_Repeat,
                "disbursedNewAndRepeating": editedValues?.Disbursed_Applications_New_And_Repeat,
                "disbursedNew": editedValues?.Disbursed_Applications_New,
                "disbursedRepeating": editedValues?.Disbursed_Applications_Repeat,
                "nonDisbursedNew": editedValues?.Non_Disbursed_Applications_New,
                "nonDisbursedRepeating": editedValues?.Non_Disbursed_Applications_Repeat,
                "nonDisbursedNewAndRepeating": editedValues?.Non_Disbursed_Applications_New_And_Repeat,
                "outstandingPrincipalLoanAmount": editedValues?.Outstanding_Principal_Loan_Amount,
                "forecloseCount": editedValues?.Foreclose_Count,
                "lock": true,
                "month": editedValues?.Month_Name,
                "createdBy": admin.emailId
            }
            SaveLockLoanApplicationMonthData(obj, callback => {
                if (callback && callback?.message == "success" && callback?.status == 200) {
                    getMonthWiseCollectionEfficiencyByDateFn(payload)
                    setpopup({ show: true, popupStatus: 'Data Saved Successfully' })
                    handleEdit(false, "")
                } else {
                    setpopup({ show: true, popupStatus: 'Error saving data' })
                }
                removePopup()
            })
        }
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                popup?.show ?
                    <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
                    : ''}

            <div className="Filterations">
                <div className="row">
                    <div className="col-lg-2 col-sm-3 col-xs-12">
                        <div className="inputgrp">
                            <label htmlFor="fromDate" className='inputlabel' style={{ fontSize: '12px' }}>From</label>
                            <input type="date" id='fromDate' className='inputtag' value={payload?.fromDate} onChange={(e) => handleDate(e, 'fromDate')} disabled={view == "edit" ? true : false} />
                        </div>
                    </div>
                    <div className="col-lg-2 col-sm-3 col-xs-12">
                        <div className="inputgrp">
                            <label htmlFor="toDate" className='inputlabel' style={{ fontSize: '12px' }}>To</label>
                            <input type="date" id='toDate' className='inputtag' value={payload?.toDate} min={payload?.fromDate} onChange={(e) => handleDate(e, 'toDate')} disabled={view == "edit" ? true : false} />
                        </div>
                    </div>
                    <div className="col-lg-2 col-sm-3 col-xs-12">
                        <div className="inputgrp">
                            <label htmlFor="" className='inputlabel' style={{ fontSize: '12px' }}>NBFC</label>
                            <select className='form-control' disabled={view == "edit" ? true : false} style={{ padding: '9px' }} onChange={(e) => handleDate(e, 'nbfcId')} value={payload?.nbfcId}>
                                <option value="">Select NBFC</option>
                                {
                                    nbfcList && nbfcList?.length > 0 ?
                                        nbfcList?.map((value, index) => {
                                            return (
                                                <option value={value?.nbfcId}>{value?.name}</option>
                                            )
                                        })
                                        : ''}
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-2 col-sm-3 col-xs-12">
                        <div className="inputgrp">
                            <label htmlFor="" className='inputlabel' style={{ fontSize: '12px' }}>Product</label>
                            <select className='form-control' disabled={view == "edit" ? true : false} style={{ padding: '9px' }} onChange={(e) => handleDate(e, 'productId')} value={payload?.productId}>
                                <option value="">Select Product</option>
                                <option value="loan">Loan</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
                        <div style={{ display: 'flex' }}>
                            <button  className='btn btn-primary' style={{ marginTop: '10px',padding:'10px 11px' }} onClick={(e) => handleDate(e, 'applyFilter')} disabled={view == "edit" ? true : false}>Apply Filter</button>
                        </div>
                    </div>

                </div>
                <div className="row" style={{ marginTop: '6px' }}>
                    <div className="col-lg-4 col-md-6 col-sm-8 col-xs-12" style={{ marginTop: '20px' }}>
                        <div className="inputgrp">
                            <label className='inputlabel' style={{ fontSize: '13px' }}>Month Wise</label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <button className={`filterbtn2 ${ActiveMonthFilter === '3month' ? 'active' : ''}`} onClick={() => handlemonthFilter('3month')} disabled={view == "edit" ? true : false} >last 3 Month</button>
                                <button className={`filterbtn2 ${ActiveMonthFilter === '6month' ? 'active' : ''}`} onClick={() => handlemonthFilter('6month')} disabled={view == "edit" ? true : false} >last 6 Month</button>
                                <button className={`filterbtn2 ${ActiveMonthFilter === '1year' ? 'active' : ''}`} onClick={() => handlemonthFilter('1year')} disabled={view == "edit" ? true : false} >last 1 Year</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <hr />

            <div className="Dashboardsmis">

                <div className="row" style={{ position: 'relative' }}>

                    <div className={`${selectedDataIndex == '-1' ? 'col-xs-12' : "col-md-6 col-xs-12"} transition-col`} style={{ boxShadow: selectedDataIndex !== '-1' ? '0 0 20px 2px #ddd' : "none" }} id="tableHeight">
                        <div className="table" style={{ marginTop: '20px' }}>
                            <div className="phocket-table-new newTable" style={{ overflowX: 'auto', marginTop: '0px' }}>
                                <table>
                                    <thead style={{ position: 'sticky', top: 0 }}>
                                        <tr>
                                            <th style={{ position: 'sticky', left: 0, zIndex: '1' }}>Particulars</th>
                                            {
                                                APIData?.length > 0 && APIData?.map((item, index) => (

                                                    <th key={index}>

                                                        <MenuBar
                                                            totalData={item}
                                                            ButtonName={item?.Month_Name}
                                                            ListType={ListType}
                                                            EditData={editedValues}
                                                            onEdit={() => {
                                                                handleEdit(true, item)
                                                            }}
                                                            onView={() => {
                                                                handleEdit(false, "")
                                                            }}
                                                            onSave={() => {
                                                                handleSavingApi("save", item)
                                                            }}
                                                            onLock={() => {
                                                                handleSavingApi("lock", item)
                                                            }}
                                                        />
                                                    </th>
                                                ))
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            APIData?.length > 0 &&
                                            Object.keys(APIData[0])?.filter(key => key !== 'Month_Name').map((fieldKey, index) => {
                                                if (fieldKey == "Month_Name" || fieldKey == "isLocked" || fieldKey == "canEdit") {
                                                    return
                                                }
                                                return (
                                                    <tr key={index} style={{ cursor: 'pointer', background: selectedDataIndex == index ? "#7fb0ae" : "" }} onClick={() => handleSelectedRow(fieldKey, index)}>
                                                        <td className='leftsticky'><b>{fieldKey?.replace(/_/g, " ")}</b></td>
                                                        {
                                                            APIData?.map((item, colIndex) => {
                                                                const isEditing = editData.show && editData.data.Month_Name === item.Month_Name;
                                                                const monthKey = item.Month_Name;
                                                                const inputKey = `${fieldKey}_${monthKey}`;
                                                                return (
                                                                    <>
                                                                        {
                                                                            isEditing ?
                                                                                <td>
                                                                                    <input style={{ border: '1px solid #ccc', borderRadius: '6px', padding: '10px' }} type="number" value={editedValues[fieldKey] ?? item[fieldKey]}
                                                                                        onChange={(e) => {
                                                                                            setEditedValues(prev => ({
                                                                                                ...prev,
                                                                                                [fieldKey]: e.target.value
                                                                                            }));
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                                :
                                                                                <td style={{ color: selectedDataIndex == index ? "#fff" : "#000" }} key={colIndex}>{item[fieldKey]}</td>
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {
                        selectedData?.length > 0 ?
                            <div className="col-md-6 col-xs-12">
                                <div className="charts" style={{ height: GraphBoxHeight, border: 'none', boxShadow: selectedDataIndex !== '-1' ? '0 0 20px 2px #ddd' : "none" }}>
                                    <h3 style={{ fontSize: '16px' }}>{selectedDataHeading?.replace(/_/g, " ")}</h3>
                                    <div className="chartbar" style={{ height: GraphBoxHeight - 50 }}>

                                        <ResponsiveContainer width="100%" height="100%">
                                            <BarChart width={150} height={40} data={selectedData}
                                                barSize={ActiveMonthFilter === '3month' ? 40 : ActiveMonthFilter === '6month' ? 30 : 20}
                                                margin={{
                                                    top: 20,
                                                    right: 0,
                                                    left: 30,
                                                    bottom: 5,
                                                }}
                                            >
                                                <defs>
                                                    <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="0%" stopColor="#8884d8" stopOpacity={1} />
                                                        <stop offset="100%" stopColor="#fff" stopOpacity={1} />
                                                    </linearGradient>
                                                </defs>
                                                <CartesianGrid stroke='none' />
                                                <XAxis dataKey="date" />
                                                <YAxis padding={{ top: 20 }} />
                                                <Tooltip />
                                                <Bar dataKey="value" fill="url(#barGradient)" radius={[10, 10, 10, 10]} />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            </div>
                            : ''}
                </div>

            </div>
        </>
    )
}

export default CACDashboard


const getDateRange = (type) => {
    const today = moment();
    let fromDate;

    if (type === "3month") {
        fromDate = moment().subtract(3, 'months').startOf('month');
    } else if (type === "6month") {
        fromDate = moment().subtract(6, 'months').startOf('month');
    } else if (type === "1year") {
        fromDate = moment().subtract(1, 'year').startOf('month');
    } else {
        return null;
    }

    const toDate = moment().subtract(1, 'months').endOf('month');

    return {
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD'),
    };
};